import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";


export const RequestResponseLandlord = createAsyncThunk(
    "dummyData/RequestResponseLandlord",
    async (payload, { rejectWithValue }) => {
      try {
        const response = await axios.put(
          `${BASE_URL}/update-maintenance-status/${payload._id}`,
          payload, // ✅ direct payload
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem("ots_token")}`,
            },
          }
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  );
  
  



const RequestResponse = createSlice({
  name: "RequestResponse",
  initialState: {
    loading: false,
    RequestResponse: [],
    error: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(RequestResponseLandlord.pending, (state) => {
        state.loading = true;
      })
      .addCase(RequestResponseLandlord.fulfilled, (state, action) => {
        state.loading = false;
        state.RequestResponse = action.payload;
      })
      .addCase(RequestResponseLandlord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default RequestResponse.reducer;